import { PaymentSuccessRateChart } from "@components/charts/PaymentsChart";
import type { Payment } from "types/payment";

export default function PaymentSuccessRateWidget({ payments }: { payments: Payment[] }) {
  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <PaymentSuccessRateChart payments={payments} />
    </div>
  );
}
